<div class="mb-15 mct-flex mct-row mct-justify-end mct-items-center">
  <button class="mct-flex atlas-btn atlas-btn-primary mr-10 mct-justify-center mct-items-center" type="button"
    title="{{ 'profiles.transactions.new-invoice' | translate | uppercase }}" [routerLink]="['/revenue/invoice/new']"
    [queryParams]="{ profileId: profileId }">
    {{ 'profiles.transactions.new-invoice' | translate | uppercase }}
  </button>
  <button class="mct-flex atlas-btn atlas-btn-primary mct-justify-center mct-items-center" type="button"
    title="{{ 'profiles.transactions.new-invoice' | translate | uppercase }}"
    [disabled]="loadingInvoiceNumbersForPayment" (click)="applyPaymentClicked()">
    <span *ngIf="!loadingInvoiceNumbersForPayment">{{ 'profiles.transactions.apply-payment' | translate | uppercase
      }}</span>
    <wl-busy *ngIf="loadingInvoiceNumbersForPayment" [show]="loadingInvoiceNumbersForPayment"></wl-busy>
  </button>
</div>

<div class="header-bar mct-flex mct-row mct-justify-between mct-items-center">
  <div class="mct-flex mct-row mct-wrap mct-justify-start mct-items-center mct-gap-10">
    <div>
      <action-button label="ACTIONS" [items]="gridMenuItems"> </action-button>
    </div>
    <span>
      {{ 'revenue.transactions-grid.there-are' | translate | ucfirst }}
      <strong>{{ selectedInvoicesCount }}</strong>
      {{ 'revenue.transactions-grid.tagged-invoices-to-take-action-on' | translate }}
    </span>
  </div>
  <div class="mct-flex mct-row mct-wrap mct-justify-start mct-items-center mct-gap-10-gt-xs">
    <wl-date-selector ngDefaultControl name="fromDate" [(ngModel)]="fromDate" (onDateChanged)="onDateSelection()">
    </wl-date-selector>
    <span class="wl-text-right tx-grid-full-lt-sm">{{ 'common.through' | translate }}</span>
    <wl-date-selector ngDefaultControl name="toDate" [(ngModel)]="toDate" [minDate]="fromDate"
      (onDateChanged)="onDateSelection()">
    </wl-date-selector>
  </div>
</div>

<p-tabs [value]="0">
  <p-tablist>
    <p-tab [value]="0">
      {{ 'revenue.transactions-grid.invoices-header' | translate | titlecase }}
    </p-tab>
    <p-tab [value]="1">
      @if(unappliedPaymentResult?.TotalBalance > 0) {
      <span>
        <span class="f-wb">{{ unappliedPaymentResult.TotalBalance | currency }} &nbsp;</span>
        <span>{{ 'common.in' | translate }}&nbsp;</span>
      </span>
      }
      <span>{{ 'revenue.transactions-grid.unapplied-payments.label' | translate | titlecase }}</span>
    </p-tab>
  </p-tablist>
  <p-tabpanels>
    <p-tabpanel [value]="0">
      <ng-template pTemplate="sorticon" field="col.field" let-sortOrder>
        <SortAltIcon *ngIf="sortOrder === 0">
          <span><i class="p-sortable-column-icon pi pi-fw pi-sort-alt" aria-hidden="true"></i></span>
        </SortAltIcon>
        <SortAmountUpAltIcon *ngIf="sortOrder === 1" [styleClass]="'p-sortable-column-icon'">
          <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt" aria-hidden="true"></i></span>
        </SortAmountUpAltIcon>
        <SortAmountDownIcon *ngIf="sortOrder === -1" [styleClass]="'p-sortable-column-icon'">
          <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-down" aria-hidden="true"></i></span>
        </SortAmountDownIcon>
      </ng-template>
      <ng-template pTemplate="header">
        <div>
          <span class="fw-b">{{ 'revenue.transactions-grid.invoices-header' | translate | titlecase }}</span>
        </div>
      </ng-template>
      <div class="atlas-table">
        <p-table [showGridlines]="true" sortField="InvoiceNum" [sortOrder]="-1" [value]="searchResult.Result" [paginator]="true"
          [rows]="searchParams ? searchParams.PageSize : 10" [lazy]="true" [totalRecords]="searchResult.TotalCount"
          (onLazyLoad)="lazyLoadInvoices($event)">
          <ng-template pTemplate="sorticon" field="col.field" let-sortOrder>
            <SortAltIcon *ngIf="sortOrder === 0">
              <span><i class="p-sortable-column-icon pi pi-fw pi-sort-alt" aria-hidden="true"></i></span>
            </SortAltIcon>
            <SortAmountUpAltIcon *ngIf="sortOrder === 1" [styleClass]="'p-sortable-column-icon'">
              <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt" aria-hidden="true"></i></span>
            </SortAmountUpAltIcon>
            <SortAmountDownIcon *ngIf="sortOrder === -1" [styleClass]="'p-sortable-column-icon'">
              <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-down" aria-hidden="true"></i></span>
            </SortAmountDownIcon>
          </ng-template>
          <ng-template pTemplate="header">
            <tr>
              <th style="width: 40px">
                <input name="headerCheckbox" type="checkbox" class="table-checkbox" [(ngModel)]="selectAll"
                  [indeterminate]="headerCheckboxIsIndeterminate" (change)="onSelectAllChange()" />
              </th>
              <th pSortableColumn="InvoiceDate">
                {{ 'revenue.transactions-grid.invoice-date' | translate | ucfirst }}
                <p-sortIcon field="InvoiceDate"></p-sortIcon>
              </th>
              <th class="right-justify" pSortableColumn="InvoiceNum">
                {{ 'revenue.transactions-grid.invoice' | translate | ucfirst }}
                <p-sortIcon field="InvoiceNum"></p-sortIcon>
              </th>
              <th class="description-column" pSortableColumn="InvoiceDescription">
                {{ 'revenue.transactions-grid.description' | translate | ucfirst }}
                <p-sortIcon field="InvoiceDescription"></p-sortIcon>
              </th>
              <th class="right-justify" pSortableColumn="DateDue">
                {{ 'revenue.transactions-grid.due-date' | translate | ucfirst }}
                <p-sortIcon field="DateDue"></p-sortIcon>
              </th>
              <th class="right-justify" pSortableColumn="TotalAmount">
                {{ 'revenue.transactions-grid.amount' | translate | ucfirst }}
                <p-sortIcon field="TotalAmount"></p-sortIcon>
              </th>
              <th class="right-justify">
                {{ 'revenue.transactions-grid.paid' | translate | ucfirst }}
              </th>
              <th class="right-justify" pSortableColumn="AmountDue">
                {{ 'revenue.transactions-grid.due' | translate | ucfirst }}
                <p-sortIcon field="AmountDue"></p-sortIcon>
              </th>
              <th class="actions-column"></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-invoice>
            <tr>
              <td style="width: 40px">
                <input name="rowCheckbox" type="checkbox" class="table-checkbox"
                  [(ngModel)]="selectedInvoices[invoice.InvoiceNum]"
                  (change)="onRowSelectionChange(invoice.InvoiceNum)" />
              </td>
              <td>
                {{ invoice.InvoiceDate | date: 'MM/dd/yyyy' }}
              </td>
              <td class="right-justify">
                <a [routerLink]="['/revenue/invoice', invoice.InvoiceNum]">{{ invoice.InvoiceNum }}</a>
              </td>
              <td class="description-column">
                <wl-expandable-transaction-description
                  [invoiceResult]="invoice"></wl-expandable-transaction-description>
              </td>
              <td class="right-justify">
                {{ invoice.DateDue | date: 'MM/dd/yyyy' }}
              </td>
              <td class="right-justify">
                <div class="mct-flex mct-row mct-justify-end mct-items-center">
                  <span>{{ invoice.TotalAmount | currency: false }}</span>
                </div>
              </td>
              <td class="right-justify">
                <div class="mct-flex mct-row mct-justify-end mct-items-center">
                  <span>{{ invoice.AmountPaid | currency: false }}</span>
                </div>
              </td>
              <td class="right-justify">
                <div class="mct-flex mct-row mct-justify-end mct-items-center">
                  <span [ngClass]="{ unpaid: invoice.AmountDue > 0, paid: invoice.AmountDue === 0 }">
                    {{ invoice.AmountDue | currency: false }}
                  </span>
                </div>
              </td>
              <td class="actions-column">
                <div>
                  <action-button [label]="'revenue.transactions-grid.actions' | translate | uppercase"
                    [items]="actionItemsForInvoice(invoice)">
                  </action-button>
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>
        <p-progressSpinner *ngIf="loading"></p-progressSpinner>
      </div>
    </p-tabpanel>
    <p-tabpanel [value]="1">
      <ng-template pTemplate="sorticon" field="col.field" let-sortOrder>
        <SortAltIcon *ngIf="sortOrder === 0">
          <span><i class="p-sortable-column-icon pi pi-fw pi-sort-alt" aria-hidden="true"></i></span>
        </SortAltIcon>
        <SortAmountUpAltIcon *ngIf="sortOrder === 1" [styleClass]="'p-sortable-column-icon'">
          <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt" aria-hidden="true"></i></span>
        </SortAmountUpAltIcon>
        <SortAmountDownIcon *ngIf="sortOrder === -1" [styleClass]="'p-sortable-column-icon'">
          <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-down" aria-hidden="true"></i></span>
        </SortAmountDownIcon>
      </ng-template>
      <ng-template pTemplate="header">
        <div class="mct-flex mct-row">
          <span *ngIf="unappliedPaymentResult?.TotalBalance > 0">
            <span class="f-wb">{{ unappliedPaymentResult.TotalBalance | currency }} &nbsp;</span>
            <span>{{ 'common.in' | translate }}</span>
          </span>
          &nbsp;
          <span>{{ 'revenue.transactions-grid.unapplied-payments.label' | translate | titlecase }}</span>
        </div>
      </ng-template>
      <div class="action-row-wrapper">
        <div class="action-row flex row-collapse items-center space-between gap-10px"
          [ngClass]="{ 'has-balance': unappliedPaymentResult?.TotalBalance > 0 }">
          <div>
            <button pButton type="button" class="atlas-btn atlas-btn-primary"
              (click)="showCreateUnappliedPaymentDialog = true">
              {{ 'revenue.transactions-grid.unapplied-payments.create-an-unapplied-payment' | translate | uppercase }}
            </button>
          </div>
          <div class="flex row-collapse items-center gap-10px">
            <div>
              <button type="button" class="atlas-btn atlas-btn-primary"
                [disabled]="unappliedPaymentResult?.TotalBalance === 0" (click)="applyUnappliedPaymentsClicked()">
                @if (!loadingInvoiceNumbersForApplyUnappliedPayments) {
                <span>
                  {{ 'revenue.transactions-grid.unapplied-payments.apply-to-invoice' | translate | uppercase }}
                </span>
                }
                @if (loadingInvoiceNumbersForApplyUnappliedPayments) {
                <wl-busy [show]="loadingInvoiceNumbersForApplyUnappliedPayments"></wl-busy>
                }
              </button>
            </div>
            @if (unappliedPaymentResult)
            {
            <div class="flex row-collapse items-center">
              {{ 'revenue.transactions-grid.unapplied-payments.unapplied-total-label' | translate | ucfirst }}
              <span class="ml-2 f-wb">{{ unappliedPaymentResult.TotalBalance | currency }}</span>
            </div>
            }
          </div>
        </div>
      </div>
      <wl-unapplied-payments-grid [profileId]="profileId"
        (loadedResults)="unappliedPaymentResult = $event"></wl-unapplied-payments-grid>
    </p-tabpanel>
  </p-tabpanels>
</p-tabs>

<wl-transactions-grid-email-dialog [show]="showEmailDialog" [invoiceSearch]="invoiceSearchToEmail"
  (cancelClicked)="showEmailDialog = false"></wl-transactions-grid-email-dialog>

<wl-transactions-grid-apply-payments-dialog [(show)]="showApplyPaymentDialog" [profileId]="profileId"
  [invoiceNumbers]="applyPaymentInvoiceNumbers"
  (paymentsApplied)="search()"></wl-transactions-grid-apply-payments-dialog>

<wl-create-unapplied-payment-dialog [(show)]="showCreateUnappliedPaymentDialog" [profileId]="profileId"
  (paymentCreated)="refreshUnappliedPayments()"></wl-create-unapplied-payment-dialog>

<wl-apply-unapplied-payments-dialog [(show)]="showApplyUnappliedPaymentsDialog"
  [invoiceNumbers]="applyPaymentInvoiceNumbers" [profileId]="profileId"
  (paymentsApplied)="refreshUnappliedPayments(); search()"></wl-apply-unapplied-payments-dialog>

<p-dialog #receiptConfirmationDialog modal="true" [(visible)]="showReceiptConfirmation" [closable]="false"
  styleClass="atlas-dialog-s" [focusOnShow]="false" [contentStyle]="{ 'max-height': '75vh' }">
  <ng-template pTemplate="header">
    {{ 'revenue.transactions-grid.receipt-confirmation.title' | translate | titlecase }}
  </ng-template>
  {{ 'revenue.transactions-grid.receipt-confirmation.message' | translate | ucfirst }}&nbsp;{{ profileReportName }}
  <ng-template pTemplate="footer">
    <button pButton type="button" class="btn btn-primary" (click)="closeReceiptConfirmation()">
      {{ 'common.ok' | translate | uppercase }}
    </button>
  </ng-template>
</p-dialog>

<p-dialog modal="true" [(visible)]="showSelectInvoicesDialog" [closable]="false" styleClass="atlas-dialog-s"
  [focusOnShow]="false" [contentStyle]="{ 'max-height': '75vh' }">
  <ng-template pTemplate="header">
    {{ 'revenue.transactions-grid.select-an-invoice' | translate | ucfirst }}
  </ng-template>
  {{ 'revenue.transactions-grid.select-invoice-for-email' | translate | ucfirst }}
  <ng-template pTemplate="footer">
    <button pButton type="button" class="atlas-btn atlas-btn-primary" (click)="showSelectInvoicesDialog = false">
      {{ 'common.ok' | translate | uppercase }}
    </button>
  </ng-template>
</p-dialog>

<wl-share-link-dialog>
  <atlas-header>{{ 'revenue.transactions-grid.share-link-dialog.title' | translate }}</atlas-header>
  <div class="mt-20"></div>
</wl-share-link-dialog>